import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { CalendarToday } from '@workwave-tidal/core/icons'
import { getIn, useFormikContext } from 'formik'
import React from 'react'
import { ImportUtilityModel } from '../../typings'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

export function ImportDatePicker({ label, name }) {
  const { values, setFieldValue, errors } =
    useFormikContext<ImportUtilityModel>()

  const { getFormat } = useLocalizationDateFormat()
  const helperText = getIn(errors, name)

  return (
    <DatePicker
      label={label}
      value={values[name]}
      format={getFormat()}
      onChange={(date) => setFieldValue(name, date)}
      slots={{
        openPickerIcon: CalendarToday,
      }}
      slotProps={{
        textField: {
          error: !!helperText,
          helperText: helperText || '',
          required: false,
          name,
          sx: { width: '100%' },
        },
      }}
    />
  )
}
